import React, { useState, useEffect } from 'react';
import ObjectivesAdminCreationHeader from './ObjectivesAdminCreationHeader';
import ObjectivesAdminCreationContent from './ObjectivesAdminCreationContent';
import dayjs from 'dayjs';
import { useLazyQuery } from '@apollo/client';
import { CSV_LOGS_PAGE } from 'Queries';

export const ObjectivesAdminCreation = () => {

  // VARIABLES DE CONTROL
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  // CONSULTA AL BACK
  const [getCsvLogsPage] = useLazyQuery(CSV_LOGS_PAGE);

  // Función para recargar la tabla con los datos (se introduce aquí para poder usarla también en la carga de datos del JSON)
  const fetchData = async (page = 0, size = pageSize) => {
    setLoading(true);
    try {
      const { data } = await getCsvLogsPage({
        variables: { page, size, sortBy: "fecha", sortDir: "desc" },
        fetchPolicy: "no-cache"
      });

      const formattedData = data.csvLogsPage.content.map((item, index) => ({
        key: index,
        fecha: dayjs(item.fecha).format('DD/MM/YYYY HH:mm'),
        distribuidor: item.codigoDistribuidor,
        objetivo: item.nombreObjetivo,
        estado: item.estado,
      }));

      setDataSource(formattedData);
      setTotalPages(data.csvLogsPage.pagination.totalPages);
      setTotalElements(data.csvLogsPage.pagination.totalElements);
    } catch (error) {
      console.error('Error al obtener datos:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(0, 10);
  }, []);

  return (
    <div>
      <ObjectivesAdminCreationHeader
        fetchData={fetchData}
        currentPage={currentPage}
        pageSize={pageSize}
      />
      <ObjectivesAdminCreationContent
        dataSource={dataSource}
        loading={loading}
        totalPages={totalPages}
        totalElements={totalElements}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        fetchData={fetchData}
        getCsvLogsPage={getCsvLogsPage}
      />
    </div>
  );
};
